var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.doi)?_c(_setup.DOILink,{attrs:{"doi":_setup.doi}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }